import * as React from 'react'
import { Props } from './types'
// @ts-ignore
import ICON_CARET from '../../assets/caret.svg'

import './styles.scss'

export class Dropdown extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}

    this.onHandleClick = this.onHandleClick.bind(this)
  }

  selectElementList(el: any, event: any) {
    const getActiveElements = document.querySelectorAll('.dropdown__active')
    const { multi } = this.props

    if (multi) {
      event.target.classList.toggle('dropdown__active')
      return
    }

    for (let i = 0; i < getActiveElements.length; i += 1) {
      getActiveElements[i].classList.remove('dropdown__active')
    }

    event.target.classList.toggle('dropdown__active')
    return
  }

  onHandleClick(event: any, element: any) {
    event.stopPropagation()
    this.selectElementList(element, event)
    const { multi } = this.props
    const getActiveElements = document.querySelectorAll('.dropdown__active')

    let finalElements: any = []

    if (multi) {
      for (let i = 0; i < getActiveElements.length; i += 1) {
        const attr = getActiveElements[i].getAttribute('data-selectedItem')

        const elements = this.props.data.find((el: any) => el.label === attr?.trim())

        if (elements) {
          finalElements = [...finalElements, elements]
        }
      }

      this.props.selectedItems(finalElements)

      return
    }

    this.props.selectedItems(element)
  }

  render() {
    const { data, multi } = this.props

    return (
      <div className="dropdown">
        { data?.map((item: any) => (
          <div
            key={item.value}
            className="dropdown__item"
            data-selectedItem={item.label}
            onClick={(event) => this.onHandleClick(event, item)}
          >
            { multi && (
              <div className="dropdown__checkbox">
                <ICON_CARET />
              </div>
            )}

            <p>{item?.label}</p>
          </div>
        ))}
      </div>
    )
  }
}
